/**
 * Chat feature component for dashboard.
 * This is a placeholder for future chat functionality.
 */
import { AppCard } from "@/components/ui";

type TChatFeatureProps = {
  sectionId: string | null;
  companyId?: string | null;
};

export function ChatFeature({ sectionId: _sectionId, companyId: _companyId }: TChatFeatureProps) {
  // Placeholder for future chat functionality
  return (
    <AppCard className="p-4">
      <h3 className="mb-4 text-base font-semibold text-foreground sm:text-lg">Chat</h3>
      <p className="text-xs text-muted-foreground sm:text-sm">Chat functionality coming soon.</p>
    </AppCard>
  );
}
